import React, { useEffect } from "react";
import styles from "./DoubleRadioButton.module.css";
import { useState, useMemo } from "react";

const DoubleRadioButton = React.memo(function ({
  leftClick = () => {},
  leftNm = "",
  rightClick = () => {},
  rightNm = "",
  disabled = false,
  defaultValue = true,
}) {
  const [state, setState] = useState({
    onOff: true,
  });
  const dynamicStyle = useMemo(() => {
    if (disabled) {
      return {
        backgroundColor: "#f2f2f2",
        color: "#999",
        borderColor: "#ccc",
        cursor: "not-allowed",
        opacity: "0.6",
      };
    } else {
      return {
        cursor: "pointer",
      };
    }
  }, [disabled]);
  const clickedLeft = () => {
    setState((s) => ({ ...s, onOff: true }));
    leftClick();
  };
  const clickedRight = () => {
    setState((s) => ({ ...s, onOff: false }));
    rightClick();
  };

  useEffect(() => {
    setState((s) => ({ ...s, onOff: defaultValue }));
  }, []);

  return (
    <div className={styles.postButtonArea}>
      <div
        className={
          state.onOff
            ? `${styles.postButton} ${styles.onBackgound}`
            : styles.postButton
        }
        style={dynamicStyle}
        onClick={clickedLeft}
      >
        <span
          className={
            state.onOff ? `${styles.post} ${styles.onLetter}` : styles.post
          }
          style={dynamicStyle}
        >
          {leftNm}
        </span>
      </div>
      <div
        className={
          !state.onOff
            ? `${styles.notPostButton} ${styles.onBackgound}`
            : styles.notPostButton
        }
        style={dynamicStyle}
        onClick={clickedRight}
      >
        <span
          className={
            !state.onOff
              ? `${styles.notPost} ${styles.onLetter}`
              : styles.notPost
          }
          style={dynamicStyle}
        >
          {rightNm}
        </span>
      </div>
    </div>
  );
});

export default DoubleRadioButton;
